<template>
	<section>
        <div>
            <div v-if="user_role === 'csm'" class="section-title">
                CUSTOMER SUCCESS DASHBOARD
            </div>
            <div v-if="user_role === 'admin'" class="section-title">
                ADMIN DASHBOARD
            </div>
            <div class="row">
                <div class="col-12 col-md-4">
	                <div class="green-content p-5 mb-4">
	                	<div class="h3 mb-4">Agencies</div>
			            <ul class="list-unstyled regular">
				            <li class="mb-2 border-bottom pb-2">
				            	<router-link tag="a" :to="{ name : user_role+'.organizations.index' }">
				            		<img width="14" src="../../assets/images/icons/solid/eye_white.svg">
				            		<span>View all</span>
				            	</router-link>
				            </li>
							<li class="mb-2">
								<router-link tag="a" :to="{ name : user_role+'.organizations.create' }">
									<img width="8" src="../../assets/images/icons/solid/plus_white.svg">
									<span class="ml-2">Add new</span>
								</router-link>
							</li>
			            </ul>
	                </div>
                </div><!--col-->
				<!-- CSM Section -->
                <div class="col-12 col-md-4" v-if="user_role!='csm'">
	                <div class="green-content p-5 mb-4">
	                	<div class="h3 mb-4">SMEs</div>
			            <ul class="list-unstyled regular">
				            <li class="mb-2 border-bottom pb-2">
				            	<router-link tag="a" :to="{ name : 'admin.smes.index' }">
				            		<img width="14" src="../../assets/images/icons/solid/eye_white.svg">
				            		<span>View all</span>
				            	</router-link>
				            </li>
							<li class="mb-2">
								<router-link tag="a" :to="{ name : 'admin.smes.create' }">
									<img width="8" src="../../assets/images/icons/solid/plus_white.svg">
									<span class="ml-2">Add new</span>
								</router-link>
							</li>
			            </ul>
	                </div>
                </div><!--col-->
                <div class="col-12 col-md-4">
	                <div class="green-content p-5 mb-4">
	                	<div class="h3 mb-4">HHAs</div>
			            <ul class="list-unstyled regular">
				            <li class="mb-2 border-bottom pb-2">
				            	<router-link tag="a" :to="{ name : user_role+'.providers.index' }">
				            		<img width="14" src="../../assets/images/icons/solid/eye_white.svg">
				            		<span>View all</span>
				            	</router-link>
				            </li>
							<li class="mb-2">
								<router-link tag="a" :to="{ name : user_role+'.providers.create' }">
									<img width="8" src="../../assets/images/icons/solid/plus_white.svg">
									<span class="ml-2">Add new</span>
								</router-link>
							</li>
			            </ul>
	                </div>
                </div><!--col-->
				<div class="col-12 col-md-4" v-if="user_role==='csm'">
	                <div class="green-content p-5 mb-4">
	                	<div class="h3 mb-4">Courses</div>
			            <ul class="list-unstyled regular">
				            <li class="mb-2 border-bottom pb-2">
				            	<router-link tag="a" :to="{ name : 'admin.courses.index' }">
				            		<img width="14" src="../../assets/images/icons/solid/eye_white.svg">
				            		<span>View all</span>
				            	</router-link>
				            </li>
							<li class="mb-2">
								<router-link tag="a" :to="{ name : 'admin.courses.create' }">
									<img width="8" src="../../assets/images/icons/solid/plus_white.svg">
									<span class="ml-2">Add new</span>
								</router-link>
							</li>
			            </ul>
	                </div>
                </div><!--col-->
            </div><!--row-->
            <div class="row">
                <div class="col-12 col-md-6" v-if="user_role!='csm'">
	                <div class="green-content p-5 mb-4">
	                	<div class="h3 mb-4">Courses</div>
			            <ul class="list-unstyled regular">
				            <li class="mb-2 border-bottom pb-2">
				            	<router-link tag="a" :to="{ name : 'admin.courses.index' }">
				            		<img width="14" src="../../assets/images/icons/solid/eye_white.svg">
				            		<span>View all</span>
				            	</router-link>
				            </li>
							<li class="mb-2">
								<router-link tag="a" :to="{ name : 'admin.courses.create' }">
									<img width="8" src="../../assets/images/icons/solid/plus_white.svg">
									<span class="ml-2">Add new</span>
								</router-link>
							</li>
			            </ul>
	                </div>
                </div><!--col-->
                <div class="col-12 col-md-6" v-if="user_role!='csm'">
	                <div class="green-content p-5 mb-4">
	                	<div class="h3 mb-4">Categories</div>
			            <ul class="list-unstyled regular">
				            <li class="mb-2 border-bottom pb-2">
				            	<router-link tag="a" :to="{ name : 'admin.categories.index' }">
				            		<img width="14" src="../../assets/images/icons/solid/eye_white.svg">
				            		<span>View all</span>
				            	</router-link>
				            </li>
							<li class="mb-2">
								<router-link tag="a" :to="{ name : 'admin.categories.create' }">
									<img width="8" src="../../assets/images/icons/solid/plus_white.svg">
									<span class="ml-2">Add new</span>
								</router-link>
							</li>
			            </ul>
	                </div>
                </div><!--col-->
            </div><!--row-->
        </div>
    </section>
</template>

<script>
import TestChart from './../charts/TestChart.js';


function notificador(){
	alert('test');
}

export default {

    components : {
        TestChart
    },

    data() {
        return {
	        
			  onClick: function(){
	              alert('eee')
              },
            chart_data : {
		            
	                labels: ["Azahara", "Robert", "Fran", "Paco", "Duar"],
			        links: ['http://google.es','http://google.es','http://google.es','http://google.es','http://marca.com'],
			      datasets: [
			        {
			          label: '',
			          backgroundColor: ["#3e95cd", "#8e5ea2","#3cba9f","#e8c3b9","#c45850"],
			          data: [30,20,54,25,12]
			        }
			      ]
              },
              myoptions:{
	            onClick:function(evt){
	                var activePoints = this.getElementsAtEvent(evt);
		            var firstPoint = activePoints[0];
					var link = this.data.links[firstPoint._index];
					alert(link);
	            },
	            responsive: false
	            
			},
			user_role:''
           }
	},
	created: function(){
		this.user_role = this.$store.getters.getRole

	},
    methods: {
	    displayNotification: function(){
			this.$snotify.success('Holi', {
				timeout: 2000,
				showProgressBar: true,
				closeOnClick: false,
				pauseOnHover: true
			});
	    },
	    graphClickEvent: function(event, array){
		    alert('yee');
		}

    }
};


</script>
<style lang="css">

.tags .vue-tags-input{
	max-width: none !important;
	margin-bottom: 30px;
}
.tags .vue-tags-input .input{
	padding: 10px;
}
.tags .tag.valid {
  background-color: #48a5a9;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/AdminDashboardComponent.vue